<script>
const Web3 = require("web3");
import Swal from "sweetalert2";
import store from "@/state/store.js";

export default {
  data() {
    return {
      connectedWallet: null,
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish",
        },
        {
          flag: require("@/assets/images/flags/china.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: this.$i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  async mounted() {
    this.value = this.languages.find((x) => x.language === this.$i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

    let accounts = await window.ethereum.request({ method: 'eth_accounts' });
    if (accounts.length != 0) {
      this.connectedWallet = accounts[0].toString();

      let client = new Web3(Web3.givenProvider);
      let chainId = await client.eth.getChainId();
      if (chainId == 56) {
        store.commit('wallet/SET_CURRENT_WALLET', accounts[0]);
      } else {
        Swal.fire("Error", "Wrong network detected", "warning");
      }
    }
 },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    /**
     * Toggle rightsidebar
     */
    // toggleRightSidebar() {
    //   this.$parent.toggleRightSidebar();
    // },
    connectWallet: async function() {
      if (this.connectedWallet != null) return;

      if (window.ethereum) {
        let result = await window.ethereum.send('eth_requestAccounts');
        window.web3 = new Web3(window.ethereum);
        this.connectedWallet = result.result[0];

        this.$store.commit('wallet/SET_CURRENT_WALLET', this.connectedWallet);
        Swal.fire("Good job!", "You are now connected", "success");
      } else {
        Swal.fire("Error", "Please use a dApp Browser", "warning");
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="https://i.ibb.co/HXbXGFf/IMG-6416.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="https://i.ibb.co/HXbXGFf/IMG-6416.png" alt height="20" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="https://i.ibb.co/HXbXGFf/IMG-6416.png" alt height="40" />
            </span>
            <span class="logo-lg">
              <img src="https://i.ibb.co/HXbXGFf/IMG-6416.png" alt height="20" />
            </span>
          </router-link>
        </div>

        <button
          @click="toggleMenu"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item vertical-menu-btn"
          id="vertical-menu-btn"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">

        <div class="dropdown d-inline-block d-lg-none">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            data-toggle="fullscreen"
            @click="connectWallet"
          >
            <img class src="https://cdn.iconscout.com/icon/free/png-512/metamask-2728406-2261817.png" alt="Header Language" height="16" />
            {{ (connectedWallet == null) ? 'Connect' : connectedWallet.substring(0, 6) + '...' }}
          </button>
        </div>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            data-toggle="fullscreen"
            @click="connectWallet"
          >
            <img class src="https://cdn.iconscout.com/icon/free/png-512/metamask-2728406-2261817.png" alt="Header Language" height="16" />
            {{ (connectedWallet == null) ? 'Connect' : connectedWallet }}
          </button>
        </div>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            data-toggle="fullscreen"
            @click="initFullScreen"
          >
            <i class="uil-minus-path"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>